import React from 'react';
import Search from './components/Search/Search';
import Features from './components/Features/Features';
import FeaturedHosts from './components/FeaturedHosts/FeaturedHosts';
import RenoCalculator from './components/RenoCalculator/RenoCalculator';
import Enquiry from './components/Enquiry/Enquiry';
// import JoinUs from './components/JoinUs/JoinUs';

const Landing = ({ history }) => {
  return (
  <>
    <Search />
    <FeaturedHosts history={history} />
    <Features />
    <RenoCalculator />
    <Enquiry />
    {/* Temporary close down this section. */}
    {/* <JoinUs /> */}
  </>
)}

export default Landing;